<template>
	<div class="episodes mid-container" v-if="item?.type === 'node--series'">
		<h2 class="vl-font-size--36 episodes--title">{{ $t("innerpage.episodes") }}</h2>
		<div class="dropdown">
			<label for="season-filter" class="hidden">{{ $t("innerpage.filter_by_season") }}:</label>
			<Dropdown
				v-model="localSelectedSeason"
				id="season-filter"
				:options="seasonOptions"
				optionLabel="label"
				optionValue="value"
			>
				<template #dropdownicon>
					<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="6.98mm" height="3.49mm" viewBox="0 0 19.8 9.9">
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1"><polygon points="0 0 9.9 9.9 19.8 0 0 0" /></g>
						</g>
					</svg>
				</template>
			</Dropdown>
		</div>
		<div class="episodes--list">
			<seriesTeaserHorizontal
				@click="playEpisode(episode)"
				v-for="(episode, key) in filteredEpisodes"
				:key="episode.drupal_internal__nid"
				:number="key + 1"
				:episode="episode"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref, onMounted, watch } from "vue"
	import seriesTeaserHorizontal from "./teaserHorizontal.vue"
	import { Episode } from "../../types/Episode"
	import { useI18n } from "vue-i18n"
	import { Movie } from "../../types/Movie"
	import { Series } from "../../types/Series"
	const { t } = useI18n()
	import { useRouter } from "vue-router"
	const router = useRouter()
	import api from "../../composables/useApi"

	const props = defineProps<{
		type: string
		item: Movie | Series
		id: number
		currentSeason: Number
	}>()
	const localSelectedSeason = ref(props.currentSeason ? Number(props.currentSeason) : 1)

	watch(
		() => props.currentSeason,
		(newVal) => {
			localSelectedSeason.value = newVal ? Number(newVal) : 1
		},
		{ immediate: true }
	)
	const { locale } = useI18n()

	const episodes = ref<Episode[]>([])
	const uniqueSeasons = ref<number[]>([])
	onMounted(async () => {
		const res = await api.get(
			`/${locale.value}/jsonapi/node/episode?jsonapi_include=1&include=field_image&filter[field_series.id]=${props.item.id}&filter[langcode]=${locale.value}`,
			{
				headers: {
					Accept: "application/vnd.api+json",
				},
			}
		)
		episodes.value = res.data.data
		uniqueSeasons.value = Array.from(new Set(episodes.value.map((ep) => ep.field_season)))
	})

	const seasonOptions = computed(() =>
		uniqueSeasons.value.map((season) => ({ label: t("innerpage.season") + season, value: season }))
	)

	const playEpisode = (episode: Episode) => {
		router.push({ name: "Watch", params: { id: episode.drupal_internal__nid, type: "episode" } })
	}

	const filteredEpisodes = computed(() => {
		if (!localSelectedSeason.value) return episodes?.value[0]?.field_season
		return episodes.value.filter((ep) => ep.field_season === localSelectedSeason.value)
	})
</script>

<style lang="scss" scoped>
	.episodes--title {
		margin: 35px 0 45px 0;
	}
	#season-filter {
		margin-left: auto;
	}
	.dropdown {
		display: flex;
	}
</style>
<style lang="scss">
	.p-select {
		--p-select-background: black;
	}
	.p-select-label {
		color: white !important;

		@include br.respond-to(br.$tablet-small) {
			font-size: 16px !important;
		}
	}
	.p-select-overlay {
		margin-top: 0px !important;
		border: 0px !important;
	}
	.p-select-list {
		padding: 0px !important;
		gap: 0px !important;
	}
	.p-select-option {
		border-radius: 0px !important;
		&.p-select-option-selected {
			background: var(--red) !important;
		}
	}
</style>
